import { render, staticRenderFns } from "./FormEmployeeTipoRegistro.vue?vue&type=template&id=aedf08b6"
import script from "./FormEmployeeTipoRegistro.vue?vue&type=script&lang=js"
export * from "./FormEmployeeTipoRegistro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports